import React from "react";

import { useStickyCondition } from "@/shared/hooks/use-sticky-condition";
import { SelectableTheme } from "@/shared/types/theme";

import * as S from "./styled";
import { ThemeButton } from "./theme-button";
const MAIN_PROJECT_LINK = "https://marginly.com/";
interface Props {
  onThemeChange: (theme: SelectableTheme) => void;
  selectableTheme: SelectableTheme;
}

export const Navigation: React.FC<Props> = ({
  onThemeChange,
  selectableTheme,
}) => {
  const ref = useStickyCondition();

  return (
    <>
      <S.Wrapper ref={ref}>
        <S.Content>
          <a href={MAIN_PROJECT_LINK}>
            <S.Logo />
          </a>
          <div>
            <ThemeButton
              onThemeChange={onThemeChange}
              selectableTheme={selectableTheme}
            />
          </div>
        </S.Content>
      </S.Wrapper>
    </>
  );
};
